import { useState,useEffect,useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../App";
import Cookie from "js-cookie"
import React from "react";

const Start_Main_SignIn_Form = (props) => {
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [message,setMessage] = useState("");

    const {setAccessToken} = useContext(AppContext);

    let navigate = useNavigate();

    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            const response = await axios.post("/login",{
                email,password
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            // console.log(response.data);
            setAccessToken(response.data);
            Cookie.set("jwttoken",response.data);
            setTimeout(() => {
                navigate("/");
            },2000);
        } catch (error) {
            setMessage(error.response.data.msg);
        }
    }
    return(
        <form className="start_main_signin_form" onSubmit={handleSubmit}>
            <input className="start_main_signin_form_input_email start_main_signin_form_input" type="email" name="email" id="signin_email" placeholder="Email" required onChange={(e) => setEmail(e.target.value)} /><br/>
            <input className="start_main_signin_form_input_password start_main_signin_form_input" type="password" name="password" id="signin_password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} /><br/>
            <input className="start_main_form_input_button start_main_start_button" type="submit" name="submit" id="signin_submit" value="Let's go" />
            <div>{message}</div>
        </form>
    )
}

export default Start_Main_SignIn_Form;